import HastaUyariKisiSorgula from "src/models/HastaUyariModels/HastaUyariKisiSorgula";
import api from "../core/api";
import VwHastaUyarilisteDTO from "src/models/HastaUyariModels/VwHastaUyarilisteDTO";

const controllerName = "HastaKaraListe";

const HastaKaraListeApi = api.injectEndpoints({
    endpoints: (builder) => ({
        HastaKaraListeEkle: builder.mutation<VwHastaUyarilisteDTO, VwHastaUyarilisteDTO>({
            query: (request) => {
                return {
                    url: `${controllerName}/HastaKaraListeEkle`,
                    method: "POST",
                    body: JSON.stringify(request),
                };
            },
        }),
        HastaKaraListeGuncelle: builder.mutation<VwHastaUyarilisteDTO, VwHastaUyarilisteDTO>({
            query: (request) => {
                return {
                    url: `${controllerName}/HastaKaraListeGuncelle`,
                    method: "PUT",
                    body: JSON.stringify(request),
                };
            },
        }),
        HastaKaraListeSil: builder.mutation<boolean, VwHastaUyarilisteDTO>({
            query: (request) => {
                return {
                    url: `${controllerName}/HastaKaraListeSil`,
                    method: "DELETE",
                    body: JSON.stringify(request),
                };
            },
        }),
        HastaKaraListeKayitSorgula: builder.query<HastaUyariKisiSorgula, { kayitAdi: string }>({
            query: (request) => {
                return {
                    url: `${controllerName}/HastaKaraListeKayitSorgula`,
                    method: "GET",
                    params: request
                };
            },
        }),
        HastaKaraListeUyariSorgula: builder.query<VwHastaUyarilisteDTO, { tcNo: string, passNo: string, dosNo: string }>({
            query: (request) => {
                return {
                    url: `${controllerName}/HastaKaraListeUyariSorgula`,
                    method: "GET",
                    params: request
                };
            },
        })
    }),
});

export const {
    useHastaKaraListeEkleMutation,
    useHastaKaraListeGuncelleMutation,
    useHastaKaraListeSilMutation,
    useLazyHastaKaraListeKayitSorgulaQuery,
    useLazyHastaKaraListeUyariSorgulaQuery,
} = HastaKaraListeApi;